import TempComp from "../components/template_component/temp";

const TempP = () => {
    return ( 
        <TempComp/>
     );
}
 
export default TempP;